/**
 * @generated SignedSource<<3eddee9d9fae0237a50bddb002c2793c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftItemTile_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HeartPill_viewer" | "NftItemTileContent_viewer">;
  readonly " $fragmentType": "NftItemTile_viewer";
};
export type NftItemTile_viewer$key = {
  readonly " $data"?: NftItemTile_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTile_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftItemTile_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeartPill_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTileContent_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "c02be4c4acc15d5f2e6fbb524d594ea0";

export default node;
